import './App.css';
import Navbar from './Components/Navbar'
import Home from './Components/Home'
import About from './Components/About'
import Vission from './Components/Vission'
import Team from './Components/Team'
import Services from './Components/Services'
import Help from './Components/Help'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
function App() {
  return (
    <>
    <Navbar/>
    <Home/>
    <About/>
    <Vission/>
    <Team/>
    <Services/>
    <Help/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;